export const COOKIE_AUTH_TOKEN_PLACEHOLDER = '__cookie_session__';

export function isCookieAuthToken(token) {
  return String(token || '') === COOKIE_AUTH_TOKEN_PLACEHOLDER;
}

function resolveWorkspaceAuthSource(result = {}, authSource = '', fallback = 'local') {
  if (authSource) {
    return authSource;
  }

  const provider = String(result?.authProvider || '').trim().toLowerCase();
  if (provider === 'clerk') {
    return 'clerk';
  }

  return fallback;
}

export function isAuthenticatedWebSession(payload) {
  return Boolean(payload?.authenticated);
}

export function isAuthenticatedBearerSession(payload) {
  return Boolean(payload?.accessToken && payload?.tenant?.id);
}

export function buildWorkspaceCookieSession(result = {}, currentSession = {}, authSource = '') {
  const resolvedAuthSource = resolveWorkspaceAuthSource(result, authSource, 'local');
  return {
    ...currentSession,
    accessToken: COOKIE_AUTH_TOKEN_PLACEHOLDER,
    refreshToken: null,
    authTransport: 'cookie',
    tenantId: result?.tenant?.id || currentSession?.tenantId || null,
    role: result?.tenant?.role || currentSession?.role || null,
    roleKey: result?.tenant?.roleKey || result?.tenant?.role || currentSession?.roleKey || currentSession?.role || null,
    roleLabel:
      result?.tenant?.roleLabel ||
      result?.tenant?.roleKey ||
      result?.tenant?.role ||
      currentSession?.roleLabel ||
      currentSession?.roleKey ||
      currentSession?.role ||
      null,
    permissions: result?.tenant?.permissions || currentSession?.permissions || [],
    user: result?.user || currentSession?.user || null,
    authSource: resolvedAuthSource,
  };
}

export function buildWorkspaceBearerSession(result = {}, currentSession = {}, authSource = '') {
  const resolvedAuthSource = resolveWorkspaceAuthSource(result, authSource, 'local');
  return {
    ...currentSession,
    accessToken: result?.accessToken || currentSession?.accessToken || null,
    refreshToken: result?.refreshToken || currentSession?.refreshToken || null,
    authTransport: 'bearer',
    tenantId: result?.tenant?.id || currentSession?.tenantId || null,
    role: result?.tenant?.role || currentSession?.role || null,
    roleKey: result?.tenant?.roleKey || result?.tenant?.role || currentSession?.roleKey || currentSession?.role || null,
    roleLabel:
      result?.tenant?.roleLabel ||
      result?.tenant?.roleKey ||
      result?.tenant?.role ||
      currentSession?.roleLabel ||
      currentSession?.roleKey ||
      currentSession?.role ||
      null,
    permissions: result?.tenant?.permissions || currentSession?.permissions || [],
    user: result?.user || currentSession?.user || null,
    authSource: resolvedAuthSource,
  };
}

export function buildAdminCookieSession(result = {}, currentSession = {}, authSource = 'clerk') {
  return {
    ...currentSession,
    accessToken: COOKIE_AUTH_TOKEN_PLACEHOLDER,
    authTransport: 'cookie',
    admin: result?.admin || currentSession?.admin || null,
    expiresIn: result?.expiresIn || currentSession?.expiresIn || null,
    issuedAt: Date.now(),
    authSource,
  };
}

export function buildCustomerPortalCookieSession(result = {}, currentSession = {}, authSource = 'clerk') {
  return {
    ...currentSession,
    accessToken: COOKIE_AUTH_TOKEN_PLACEHOLDER,
    authTransport: 'cookie',
    user: result?.user || currentSession?.user || null,
    profile: result?.profile || currentSession?.profile || null,
    scope: 'customer_portal',
    authSource,
  };
}
